import type { ComponentType, ReactNode, SVGProps } from "react";
import { AuthCard } from "./auth-card";

type AuthStatusPanelProps = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  description: ReactNode;
  /** Optional action below the text, e.g. a back-to-login button. */
  children?: ReactNode;
};

/** Confirmation card per Figma "Email Sent" / "Password Changed" frames. */
export function AuthStatusPanel({
  icon: Icon,
  title,
  description,
  children,
}: AuthStatusPanelProps) {
  return (
    <AuthCard>
      <div className="flex flex-col gap-3">
        <Icon
          aria-hidden
          className="size-12 fill-(--schemes-secondary) text-(--schemes-secondary)"
        />
        <h1 className="text-heading-medium tracking-[-0.56px] text-foreground">
          {title}
        </h1>
        <p className="text-label-medium text-muted-foreground">{description}</p>
      </div>
      {children}
    </AuthCard>
  );
}
